import React from 'react';

import {IBatchResult} from 'entities/monitor';

import LinkButton from '../../../../../shared/ui/Button/LinkButton/LinkButton';
import ModalBodyWrapper from '../../../../../shared/ui/Modal/ModalBodyWrapper';
import ProgressBar from '../../../../../shared/ui/ProgressBar/ProgressBar';

interface IMonitorsExportFormProps {
    result: IBatchResult,
    entityName?: string
}
const UsersExportResponseHandler: React.FC<IMonitorsExportFormProps> = ({result, entityName = 'пользователей'}) => {

    const url = result.payload.url;

    return (
        <>
            <ModalBodyWrapper>
                <div className="mb-3">
                    <ProgressBar percent={result.progress ?? 100}/>
                </div>
                <p className="text-medium">Экспортировано {entityName}: {result.success_count}</p>
            </ModalBodyWrapper>
            {
                (url) ?
                    <LinkButton href={url} block>
                    Скачать
                    </LinkButton>
                    : 'Что-то пошло не так'
            }
        </>
    );
};

export default UsersExportResponseHandler;